@if (!isAuthBridgeRoute) {
  <app-header [mode]="headerMode"></app-header>
}
<router-outlet></router-outlet>
@if (!isAuthBridgeRoute) {
  <app-floating-dialogs-host></app-floating-dialogs-host>
  @if (showFeedbackButton()) {
    <app-feedback-button></app-feedback-button>
  }
}